<template  > 
  <div class="Bgc-white" v-if="banToken">
    <Header />
    <SidebarTop v-show="sidebarTopOff" position="top" :searchdata="searchData" />
    <div class="container container-siderbarTop container--estandar">
      <p class="superTitle">{{titleBusquedaTarifa}}</p>
      <Loader v-if="!banTitleBusquedaTarifa" />
      <div class="PC-cardImage PC-cardImage--bg PC-cardImage--lg PC-cardImage--border" v-if="banTitleBusquedaTarifa">

        <div class="PC-cardImage__image" :style="'background: url('+hotelMainImage+')'">
          <p v-if="hotelMainImage===$t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible')">{{hotelMainImage}}</p>
        </div>
        <div class="PC-cardImage__text">

          <p class="title">{{hotelName}}</p>
          <p> {{hotelDescription}}
          </p>
          <ul class="list-inline">
            <li class="list-inline-item" v-for="(amenity, index) in amenityList" :key="'amenity_'+index">
              <img :id="'amenity_'+index" :src="amenity.amenityIcon">
              <b-popover :target="'amenity_'+index" title="" triggers="hover focus" placement="top"
                         customClass="PC-popover" :content="amenity.amenityName"></b-popover>
            </li>
          </ul>
          <p class="tag-flex m-b-0">
            <span v-if="(dataConsiEspe.status==='true'?true:false)" class="corpo-tag">{{$t('language.posadasCorporate.busquedaPorTarifa.consideracionesEspeciales')}}</span>
            <span></span>
            <a class="PC-link--color" @click.prevent="$bvModal.show('detalleCompleto')" onclick="return false;" href="#">{{$t('language.posadasCorporate.busquedaPorTarifa.detalleCompleto')}}</a>
          </p>

        </div>

      </div>
      
      <hr ref="top">
      <div id="sirPublic" v-show="(!selectedRoom && banTitleBusquedaTarifa)">
        <p class="superTitle">{{$t('language.posadasCorporate.busquedaPorTarifa.reservacion')}}</p>

        <!-- just One Room -->
        <p v-if="justOne" class="PC-text--size16">{{$t('language.posadasCorporate.moreThan1.justOne')}}</p>
        <!-- More than One room -->
        <p v-if="moreThanOne" class="PC-text--size16">{{$t('language.posadasCorporate.moreThan1.moreThanOne')}}</p>



        <ul  class="PC-menutabs PC-menutabs--cols2">
          <li id="sirPublic1" v-bind:class="{'PC-menutabs--active':tabActive == 1}" @click="tarifas(1)" v-on:click.prevent="tabActive=1" v-if="banNR">
            <a href="#">{{$t('language.posadasCorporate.busquedaPorTarifa.tarifasNegociadas')}}</a>
          </li>
          <li id="sirPublic2"  v-bind:class="{'PC-menutabs--active':tabActive == 2}" @click="tarifas(2)" v-on:click.prevent="tabActive=2" v-if="banPR">
            <a href="#">{{(banEtiquetaMasTarifas?$t('language.posadasCorporate.busquedaPorTarifa.masTarifas'):$t('language.posadasCorporate.busquedaPorTarifa.tarifasPublicas'))}}</a> <!-- Más Tarifas -->
          </li>
        </ul>
        <p class="filtros text-right">

          <a class="PC-link--color d-inline-block" v-if="banMM" @click="orderMenorMayor('menorAMayor')" onclick="return false;" href="#">{{$t('language.posadasCorporate.busquedaPorTarifa.menorMayor')}} <i
            class="iconFiltros icon-order"></i></a>
          <a class="PC-link--color d-inline-block" v-if="!banMM" @click="orderMenorMayor('mayorAMenor')" onclick="return false;" href="#">{{$t('language.posadasCorporate.busquedaPorTarifa.mayorMenor')}} <i
            class="iconFiltros icon-order"></i></a>
        </p>
        <!-- AQUÍ COMIENZA TARIFAS PUBLICAS Y NEGOCIADAS -->

        <div v-if="banRenderRoomList">
          <div class="PC-cardImage PC-cardImage--bg PC-cardImage--shadow PC-cardTarifas"
               v-for="(room, index) in rooms" :key="room.id">
            <div class="PC-cardImage__image" :style="'background: url('+room.img+')'">
              <p v-if="room.img===$t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible')">{{room.img}}</p>
            </div>
            <div class="PC-cardImage__text">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <p class="PC-text--bold titulo">{{room.title}}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-sm-right politicas"><a class="PC-link--color" onclick="return false;" href="#"
                                                        @click="consultaPoliticaCambioCancelcion(room, 1)">{{$t('language.posadasCorporate.busquedaPorTarifa.verPoliticas')}}</a></p>
                </div>
              </div>
              <p class="descripcion mb-3 mb-lg-0" :class="[room.elipse ? 'descripcionElipse' : '']">{{room.desc}}</p>
              <p class="verMas azulBase mt-2" @click="room.elipse = !room.elipse">{{$t('language.posadasCorporate.busquedaPorTarifa.ver')}} {{room.elipse ? $t('language.posadasCorporate.busquedaPorTarifa.mas') : $t('language.posadasCorporate.busquedaPorTarifa.menos')}}</p>
              <p class="text-right total"><span>{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{room.nights}} {{(room.nights==1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches'))}}: </span> <span><b> {{((tipoClienteID===pyp||tipoClienteID===pypsa||!showRates)&&tabActive===1?guiones:globalFunctions.numberFormat(room.price, 2, '.', ','))}}</b> {{room.negotiatedRatesDetailPrice.currencyCode}}</span></p>

              <p class="tag-flex m-b-0">
                <!-- se comenta para la iterción 4 -->
                <span v-if="(banEtiquetaMasTarifas&&tabActive==2&&(room.negotiatedRatesDetailPrice.rateType=='Tarifa Pública'||room.negotiatedRatesDetailPrice.rateType=='Public Rate')?true:false)"
                  class="corpo-tag_1">{{room.negotiatedRatesDetailPrice.rateType}}</span>
                <span v-if="(banEtiquetaMasTarifas&&tabActive==2&&(room.negotiatedRatesDetailPrice.rateType=='Tarifa Combinada'||room.negotiatedRatesDetailPrice.rateType=='Mixed Rate')?true:false)"
                  class="corpo-tag">{{room.negotiatedRatesDetailPrice.rateType}}</span>
                <span></span>
                <a class="PC-link--color" @click.prevent="whichRoomCode(room, room.roomCode, index)" href="#">
                  {{$t('language.posadasCorporate.busquedaPorTarifa.verDetalleCosto')}}
                </a>
              </p>

              <hr>
              <p class="text-right seleccionar">
                <Loader v-if="banSelectedRoom&&idxDetailCosto===index" :key="index"/>
                <a class="PC-link--color"
                   v-b-popover.hover.top="{ content: rooms[index].negotiatedRatesDetailPrice.contractCode + (rooms[index].negotiatedRatesDetailPrice.complementaryContractCode===null||rooms[index].negotiatedRatesDetailPrice.complementaryContractCode===''?'':' - ' + rooms[index].negotiatedRatesDetailPrice.complementaryContractCode) + (rooms[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode===null||rooms[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode===''?'':' - ' + rooms[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode), customClass:'PC-popover' }"
                   @click.prevent="selectRoom(room, index); saveModalCost(room);" href="#">
                  {{$t('language.posadasCorporate.busquedaPorTarifa.seleccionarEstaHabitacion')}} <span class="icon-right"></span>
                </a>
              </p>
            </div>
          </div>
        </div>
        <!-- AQUÍ TERMINA EL NUEVO LAYOUT PARA TARIFAS COMBINADAS ORDENADAS DE MAYOR A MENOR Y DE MENOR A MAYOR -->

        <!-- OPCIÓN PARA VER MAS TARIFAS O VER MENOS TARIFAS -->
        <div>
          <div v-if="showRatesDepends" class="pb-4 text-center">
            <span v-if="!masResultados" class="link click font-weight-bold" style="cursor: pointer;" @click="verMas()">{{$t('language.posadasCorporate.busquedaPorTarifa.seeMoreNow')}}</span>
            <span v-if="masResultados" class="link click font-weight-bold" style="cursor: pointer;" @click="verMenos()">{{$t('language.posadasCorporate.busquedaPorTarifa.seeLessNow')}}</span>
          </div>
          <div v-if="!showFooterText" class="pb-5">
            <div class="row no-gutters">
              <div class="col-12">
                <p class="PC-text--bold titulo mb-0 pb-0">{{$t('language.posadasCorporate.busquedaPorTarifa.footerText1')}}</p>
                <p class="mt-1 pt-0">{{$t('language.posadasCorporate.busquedaPorTarifa.footerText2')}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- AQUÍ COMIENZA LA SECCIÓN DE "OTRAS" TARIFAS -->
        <div v-if="showMorePublicRates">
          <div class="PC-cardImage PC-cardImage--bg PC-cardImage--shadow PC-cardTarifas"
               v-for="(room, index) in morePublicRates" :key="room.id">
            <div class="PC-cardImage__image" :style="'background: url('+room.img+')'">
              <p v-if="room.img===$t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible')">{{room.img}}</p>
            </div>
            <div class="PC-cardImage__text">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <p class="PC-text--bold titulo">{{room.title}}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-sm-right politicas"><a class="PC-link--color" onclick="return false;" href="#"
                                                        @click="consultaPoliticaCambioCancelcion(room, 1)">{{$t('language.posadasCorporate.busquedaPorTarifa.verPoliticas')}}</a></p>
                </div>
              </div>
              <p class="descripcion mb-3 mb-lg-0" :class="[room.elipse ? 'descripcionElipse' : '']">{{room.desc}}</p>
              <p class="verMas azulBase mt-2" @click="room.elipse = !room.elipse">{{$t('language.posadasCorporate.busquedaPorTarifa.ver')}} {{room.elipse ? $t('language.posadasCorporate.busquedaPorTarifa.mas') : $t('language.posadasCorporate.busquedaPorTarifa.menos')}}</p>
              <p class="text-right total"><span>{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{room.nights}} {{(room.nights==1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches'))}}: </span> <span><b> {{((tipoClienteID===pyp||tipoClienteID===pypsa||!showRates)&&tabActive===1?guiones:globalFunctions.numberFormat(room.price, 2, '.', ','))}}</b> {{room.negotiatedRatesDetailPrice.currencyCode}}</span></p>

              <p class="tag-flex m-b-0">
                <span v-if="(banEtiquetaMasTarifas&&tabActive==2&&(room.negotiatedRatesDetailPrice.rateType=='Tarifa Pública'||room.negotiatedRatesDetailPrice.rateType=='Public Rate')?true:false)"
                  class="corpo-tag_1">{{room.negotiatedRatesDetailPrice.rateType}}</span>
                <span v-if="(banEtiquetaMasTarifas&&tabActive==2&&(room.negotiatedRatesDetailPrice.rateType=='Tarifa Combinada'||room.negotiatedRatesDetailPrice.rateType=='Mixed Rate')?true:false)"
                  class="corpo-tag">{{room.negotiatedRatesDetailPrice.rateType}}</span>
                <span></span>
                <a class="PC-link--color" @click.prevent="whichRoomCode(room, room.roomCode, index)" href="#">
                  {{$t('language.posadasCorporate.busquedaPorTarifa.verDetalleCosto')}}
                </a>
              </p>
              <hr>
              <p class="text-right seleccionar">
                <a class="PC-link--color"
                   v-b-popover.hover.top="{ content: morePublicRates[index].negotiatedRatesDetailPrice.contractCode + (morePublicRates[index].negotiatedRatesDetailPrice.complementaryContractCode===null||morePublicRates[index].negotiatedRatesDetailPrice.complementaryContractCode===''?'':' - ' + morePublicRates[index].negotiatedRatesDetailPrice.complementaryContractCode) + (morePublicRates[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode===null||morePublicRates[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode===''?'':' - ' + morePublicRates[index].negotiatedRatesDetailPrice.ratesDetailResponses[0].levelCode), customClass:'PC-popover' }"
                   @click.prevent="selectRoom(room, index); saveModalCost(room);" href="#">
                  {{$t('language.posadasCorporate.busquedaPorTarifa.seleccionarEstaHabitacion')}} <span class="icon-right"></span>
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- FOOTER TEXT -->
        <div>
          <div v-if="showFooterText" class="pb-5">
            <div class="row no-gutters">
              <div class="col-12">
                <p class="PC-text--bold titulo mb-0 pb-0">{{$t('language.posadasCorporate.busquedaPorTarifa.footerText1')}}</p>
                <p class="mt-1 pt-0">{{$t('language.posadasCorporate.busquedaPorTarifa.footerText2')}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- END OF FOOTER TEXT -->
        <!-- AQUÍ TERMINA LA SECCIÓN DE "OTRAS" TARIFAS -->

      </div>
      <div v-if="selectedRoom && banTitleBusquedaTarifa">
        <div class="row no-gutters">
          <div class="col-md-6">
            <p class="superTitle">{{$t('language.posadasCorporate.busquedaPorTarifa.hHabitacion')}}</p>
          </div>
          <div class="col-md-6">
            <p class="text-sm-right politicas"><a class="PC-link--color PC-text--semibold"
                                                  @click.prevent="editRoom()" href="#">{{$t('language.posadasCorporate.busquedaPorTarifa.cambiarHabitacion')}}</a></p>
          </div>
        </div>
        <p>{{$t('language.posadasCorporate.busquedaPorTarifa.tipoHabitacionSeleccionado')}}</p>
        <div
          class="PC-cardImage PC-cardImage--bg PC-cardImage--border PC-cardImage--sm PC-cardTarifas m-b-50">
          <div class="PC-cardImage__image" :style="'background: url('+selectedRoom.img+')'">
            <p v-if="selectedRoom.img===$t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible')">{{selectedRoom.img}}</p>
          </div>
          <div class="PC-cardImage__text">
            <div class="row no-gutters">
              <div class="col-md-6">
                <p class="PC-text--bold titulo">{{selectedRoom.title}}</p>
              </div>
              <div class="col-md-6">
                <p class="text-sm-right politicas"><a class="PC-link--color" onclick="return false;" href="#"
                                                      @click="consultaPoliticaCambioCancelcion(selectedRoom, 1)">{{$t('language.posadasCorporate.busquedaPorTarifa.verPoliticasCambioCancelacion')}}</a></p>
              </div>
            </div>
            <p class="descripcion mb-3 mb-lg-0" :class="[elipse ? 'descripcionElipse' : '']">
              {{selectedRoom.desc}}</p>
            <p class="verMas azulBase mt-2" @click="elipse = !elipse">Ver
              {{elipse ? $t('language.posadasCorporate.busquedaPorTarifa.mas') : $t('language.posadasCorporate.busquedaPorTarifa.menos')}}</p>
            <p class="text-right total"><span>{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{selectedRoom.nights}} {{(selectedRoom.nights==1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches'))}}: </span> <span><b>
                  {{((tipoClienteID===pyp||tipoClienteID===pypsa||!showRates)&&tabActive===1?guiones:globalFunctions.numberFormat(selectedRoom.price, 2, '.', ','))}}</b> {{selectedRoom.negotiatedRatesDetailPrice.currencyCode}}</span></p>

            <p class="text-right ver-detalle"><a class="PC-link--color"
                                                 href="#" @click.prevent="whichRoomCode(selectedRoom, selectedRoom.roomCode, idxDetailCosto)">{{$t('language.posadasCorporate.busquedaPorTarifa.verDetalleCosto')}}</a>
            </p>
          </div>
        </div>
        <div class="row m-b-50">
          <div class="col-md-4 offset-md-8">
            <button @click="selectedHotel">{{$t('language.posadasCorporate.busquedaPorTarifa.continuar')}}</button>
          </div>
        </div>
      </div>
      <!-- INICIO: MODALS -->
      <b-modal id="politicasCambioCancelacion" footer-class="extra-light" hide-header>

        <p class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.busquedaPorTarifa.politicasCambioCancelacion')}}</p>
        <div role="tablist">
          <b-card no-body class="mb-1 PC-card--collapsible" v-for="(item,index) in politicas.listPoliticas" :key="'item_'+index">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle="'politica_'+index">{{item.title}}</b-button>
            </b-card-header>
            <b-collapse :id="'politica_'+index"
                        :accordion="'politicas-cambio-cancelacion-'+index" role="tabpanel">
              <b-card-body>
                <!-- KB48764 By m.a.cortes -->
                <b-card-text>{{changePolicy( item.description,item.penaltyQuantity, guiones,tipoTarifa,tipoClienteID)}}</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <a class="PC-link--color d-inline-block mt-3" @click="redirectPrivacyPolicy" onclick="return false;" href="#"><b>{{$t('language.posadasCorporate.busquedaPorTarifa.avisoPrivaciodad')}} <i
            class="iconFiltros icon-report"></i></b></a>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="col-12 col-md-6 float-right">
            <button @click="$bvModal.hide('politicasCambioCancelacion')">
              {{$t('language.posadasCorporate.busquedaPorTarifa.entendido')}}
            </button>
          </div>
        </div>
      </b-modal>

      <!--  MODAL NUITS -->
      <DetalleCostos v-if="banDetCost" :key="componentKey" ></DetalleCostos> <!--:infoCosto="infoCosto" -->
      <!--  MODAL NUITS -->

      <b-modal id="detalleCompleto" content-class="modalReservaciones" size="lg" hide-footer>
        <template slot="modal-title">
          <lingallery :iid.sync="currentId" :items="justForFun"/>
        </template>
        <template slot="modal-header-close">
          <b-button class="mt-3 closeModal" variant="outline-warning" block @click="$bvModal.hide('detalleCompleto')">
            <i class="icon-close"></i>
          </b-button>
        </template>
        <div class="d-block">
          <p class="title">{{hotelName}}</p>
          <p>{{hotelDescription}}</p>
        </div>

        <div class="d-block">
          <p v-if="(dataConsiEspe.status==='true'?true:false)">
            <span class="f-w-500">{{$t('language.posadasCorporate.busquedaPorTarifa.consideracionesEspeciales')}}:</span> {{ dataConsiEspe.aviso }}
          </p>
        </div>

        <div class="d-block">
          <div v-b-toggle="'comodidades'" class="row acordion" @click="[comodidades = !comodidades]">
            <div class="col-10 mb-1">
              <p><b>{{ $t('language.posadasCorporate.hotelCards.hotelServices') }}</b></p>
            </div>
            <div class="naviagate col-2 text-center">
              <i class="navi icon-navigate-down" :class="[comodidades ? '' : 'oculto']"></i>
              <i class="navi icon-up" :class="[comodidades ? 'oculto' : '']"></i>
            </div>
          </div>
          <b-collapse visible id="comodidades">
            <ul class="listIconModal row">
              <div class="col-12 col-lg-6">

                <li class="flex"  v-for="(amenity, index) in amenityList" :key="'amenity_'+index">
                  <img :id="'amenity_'+index" :src="amenity.amenityIcon"><p class="m-b-0"> {{amenity.amenityName}}</p>
                  <b-popover
                    :target="'amenity_'+index"
                    title=""
                    triggers="hover focus"
                    placement="top"
                    customClass="PC-popover"
                    :content="amenity.amenityName"
                  ></b-popover>
                </li>
              </div>
              <div class="col-12 col-lg-6">

                <li class="flex"  v-for="(amenity, index) in amenityListRight" :key="'amenity_'+index">
                  <img :id="'amenity_'+index" :src="amenity.amenityIcon"><p class="m-b-0"> {{amenity.amenityName}}</p>
                  <b-popover
                    :target="'amenity_'+index"
                    title=""
                    triggers="hover focus"
                    placement="top"
                    customClass="PC-popover"
                    :content="amenity.amenityName"
                  ></b-popover>
                </li>

              </div>
            </ul>
          </b-collapse>
        </div>

        <div class="d-block">
          <div v-b-toggle="'ubicacion'" class="row acordion" @click="[ubicacion = !ubicacion]">
            <div class="col-10 mb-1">
              <p><b>{{ $t('language.posadasCorporate.hotelCards.location') }}</b></p>
            </div>
            <div class="naviagate col-2 text-center">
              <i class="navi icon-navigate-down" :class="[ubicacion ? '' : 'oculto']" ></i>
              <i class="navi icon-up" :class="[ubicacion ? 'oculto' : '']"></i>
            </div>
          </div>
          <b-collapse visible id="ubicacion">
            <ul class="listIconModal row">
              <div class="col-12 col-lg-6">
                <li class="d-inline-flex d-lg-flex" v-if="(hotelPhone===''?false:true)">
                  <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/ic_tel.svg">
                  <p class="m-b-0">{{hotelPhone}}&nbsp;</p>
                </li>
                <li class="d-inline-flex d-lg-flex m-b-5" v-if="(hotelFax===''?false:true)">
                  <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/ic_tel.svg">
                  <p class="m-b-0">{{hotelFax}}</p>
                </li>
                <li class="flex align-flex-start">
                  <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/location.svg">
                  <p class="m-b-0">{{hotelAddress}}<br><br>
                  </p>
                </li>
                <li class="row">
                  <div class="col-1"></div>
                  <p class="col-9 mb-1 subtitle azulBase cursor" @click="redirectMap">{{ $t('language.posadasCorporate.hotelCards.seeMaps') }}
                    <i class="demo-icon icon-arrow-right subtitle azulBase"></i>
                  </p>
                </li>
              </div>
              <div class="col-12 col-lg-6">
                <iframe
                  width="100%"
                  height="100%"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  :src="srcMaps"
                >
                </iframe>
              </div>
            </ul>
          </b-collapse>
        </div>

        <div class="d-block">
          <div v-b-toggle="'horarios'" class="row acordion" @click="[horarios = !horarios]">
            <div class="col-10 mb-1">
              <p><b>{{ $t('language.posadasCorporate.hotelCards.schedule') }}</b></p>
            </div>
            <div class="naviagate col-2 text-center">
              <i class="navi icon-navigate-down" :class="[horarios ? '' : 'oculto']" ></i>
              <i class="navi icon-up" :class="[horarios ? 'oculto' : '']"></i>
            </div>
          </div>
          <b-collapse visible id="horarios">
            <ul class="listIconModal row">
              <div class="col-6">
                <li class="flex">
                  <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/check-in.svg">
                  <p class="m-b-0">{{ $t('language.posadasCorporate.hotelCards.in') }}: {{ hotelCardEntrada }}</p></li>
              </div>
              <div class="col-6">
                <li class="flex">
                  <img class="amenidad-icon-size-18 amenidad-modal" src="@/assets/img/icons/check-out.svg">
                  <p class="m-b-0">{{ $t('language.posadasCorporate.hotelCards.out') }}: {{ hotelCardSalida }}</p>
                </li>
              </div>
            </ul>
          </b-collapse>
        </div>

        <div class="d-block pt-4">
          <div class="row d-flex justify-content-end">
            <div class="col-12 col-lg-6 order-1 order-lg-2 mb-3 mb-lg-0">
              <b-button class="mt-3 button btnModal" variant="outline" block @click="$bvModal.hide('detalleCompleto')">{{ $t('language.posadasCorporate.hotelCards.ok') }}</b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- EXPIRED SESSION MODAL  -->
      <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
        <template slot="header">
          <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
        </template>
        <template slot="body">
          <p class="Ta-left">
            {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
          </p>
        </template>
        <template slot="footer">

          <button type="button" class="button btn-primary" @click="closeExpiredModal"
                  aria-label="Close modal">
            {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
          </button>


        </template>
      </modal>
      <!-- EXPIRED SESSION MODAL  -->      <!-- FIN: MODALS -->

    <modal v-if="isModalPoliticasVisible" @close="closeModalImportant" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.tarEspecial.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.tarEspecial.body') }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="closeModalImportant" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.tarEspecial.entendido') }}
        </button>
      </template>
    </modal>

    </div>

    <Footer />


  </div>
</template>
<script>

  import * as GlobalFunctions from "../../../utils/GlobalFunctions";
  import * as GlobalServices from "../../../utils/GlobalServices";
  import Modal from '../../addons/Modal.vue'
  import SidebarTop from '../SidebarTop.vue';
  import Mixin from '../../../mixins/commons.js';
  import Lingallery from 'lingallery';
  import axios from 'axios';
  import SecureLS from 'secure-ls';
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import DetalleCostos from '../DetalleCostos';
  import i18n from '../../../plugins/i18n';
  import Loader from '../../loader/Loader';
  export default {
    name: 'BusquedaPorTarifa',
    components: {
      Header,
      SidebarTop,
      Footer,
      Lingallery,
      DetalleCostos,
      Loader,
      Modal
    },
    mixins: [Mixin],
    data: () => {
      return {
        hora11: '11:00',
        hora15: '15:00',
        hotelCardEntrada: '15:00',
        hotelCardSalida: '12:00',
        codigoHotel: '',
        banEtiquetaMasTarifas: false,
        fai: false,
        isModalPoliticasVisible: false,
        dataConsiEspe: {
          status: false,
          aviso: ''
        },
        rmsC: 0,
        rmsI: [],
        sidebarTopOff: false,
        banSelectedRoom: false,
        roomsCombined: [],
        renderCombinedRooms: false,
        tarifasPublicasParaFusion: [],
        showFooterText: false,
        showMorePublicRates: false,
        showRatesDepends: false,
        morePublicRates: [],
        counterText: 1,
        isExpiredModalVisible: false,
        componentKey: 0,
        componentKey2: 0,

        moreThanOne: false,
        justOne: false,
        modalSpecialMessage: false,
        masResultados: false,
        textVerMas: 'Ver más tarifas',
        textVerMenosTarifas : 'Ver menos tarifas',
        iconoActivo: 0,
        isModalVisible: false,
        multiple: false,
        pyp: 'PYP', //no cambiar este valor
        pypsa: 'PYPSA', //no cambiar este valor
        showRates: null,
        tipoClienteID: '',
        guiones: '-------', //no cambiar este valor
        banNR: true,
        banPR: true,
        contTitleBusquedaTarifa: 0,
        banTitleBusquedaTarifa: false,
        banDetCost: false,
        infoCosto: null,
        average: null,
        noches: null,
        twoPolicy: 'igual a 2',
        twoPolicyEn: 'equal to 2',
        globalFunctions: GlobalFunctions,
        srcMaps: '',
        contract: '',
        commissionPercentage: '',
        commissionAmount: '',
        baseAmount: '',
        showTableTooltip: false,
        negotiatedTableTooltips: [],
        publicTooltipsTables: [],
        banMM: false,
        datosHabHotModalCosto: {
          habitacion: null,
          hotel: null,
          localStor: null,
          userClientID: false,
          tabActive: null
        },
        datosHabHot: {
          habitacion: null,
          hotel: null,
          politicas: null,
          hotelName: null,
          localStor: null,
          countryDir: null,
          cityDir: null,
          userClientID: false,
          tabActive: null,
          mojito: false,
          specialMessage: null
        },
        idxDetailCosto: null,
        banModDetCosto: false,
        ls: new SecureLS({encodingType: 'aes'}),
        banToken: false,
        banRenderRoomList: false,
        tooltipBody: '',
        publicTooltipsText: [],
        tooltipTitle: '',
        showTextTooltip: false,
        whichNightSelected: '',
        hotelMainImage: '',
        hotelMailImage: '',
        negotiatedTooltipsText: [],
        roomCodeForTextTooltip: '',
        hotelPhone: null,
        hotelAddress: '',
        hotelFax: null,
        hotelHoraEntrada: '',
        hotelHoraSalida: '',
        amenityListRight: [],
        justForFun: [],
        hotelCarrouselImages: [],
        hotelName: '',
        hotelDescription: '',
        tabActive: 1,
        language: '',
        token: '',
        selectedRoom: null,
        elipse: true,
        //SIMULAR DATOS
        searchData: {
          hotel: 'Grand Fiesta Americana',
          fechas: {
            checkin: new Date(),
            checkout: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3),
          },
          tipoHabitacion: 'Todos los tipos de habitaciones',
          habitaciones: 5,
          tipoMoneda: 'mxn',
          codigo: { descuento: '50%', promocion: 'REWARDS-VERANO' },
        },
        rooms: [],
        amenityList: [],
        politicas: {
          listPoliticas: null,
          privacyPolicyURL: null,
        },
        comodidades: false,
        ubicacion: false,
        horarios: false,
        currentId: null,
      };
    },
    computed: {
      unlockLanguages() {
        this.$store.commit('blockLanguages', {turn: true})

        return this.$store.getters.gettingLangBlock
      },
      costDetailCounter() {
        return this.$store.getters.gettingCostDetailCounter
      },
      specialMessageC() {
        return   this.$store.getters.gettingSpecialMessageForDiscounts

      },
      titleBusquedaTarifa(){
        this.changeLanguage();
        return i18n.t('language.posadasCorporate.busquedaPorTarifa.reservacion');
      },
      newInfo() {
        this.$store.commit("clodeSliderNow")
        return this.$store.getters.gettingStateHotelInfo
      },
      toll() {
        return this.$store.getters.gettingToll
      }
    },
    watch: {
      morePublicRates() {
        if(this.morePublicRates.length != 0 && this.tabActive == 2) {
          this.showRatesDepends = true
        }
      },
      unlockLanguages() {
        if(this.unlockLanguages) {
          this.$store.commit('blockLanguages', {turn: false})
        }
      },
      newInfo() {
        var ls = new SecureLS({encodingType: 'aes'});
        var aa = ls.get('justPublicSir');
        setTimeout(function(){
          if(aa.data) {
            var lis = document.getElementById("sirPublic").getElementsByTagName("li");
            document.getElementById(lis[1].id).click();
          } else {
            var lis = document.getElementById("sirPublic").getElementsByTagName("li");
            document.getElementById(lis[1].id).click();

          }
        }, 1);
        this.banTitleBusquedaTarifa = false;
        if (this.contTitleBusquedaTarifa != 0) {
          this.puff()
        }
      },
      toll() {
        this.banTitleBusquedaTarifa = false;
        if (this.contTitleBusquedaTarifa != 0) {
          this.puff()
        }
      },
      whichNightSelected() {
        if(this.tabActive == 1) {
          // Here comes negotiatedRates tables
          for(var x = 0; x < this.negotiatedTableTooltips.length; x++) {
            if(this.whichNightSelected == this.negotiatedTableTooltips[x].night) {
              this.baseAmount = this.negotiatedTableTooltips[x].commissionResponse.baseAmount
              this.commissionAmount = this.negotiatedTableTooltips[x].commissionResponse.commissionAmount
              this.commissionPercentage = this.negotiatedTableTooltips[x].commissionResponse.commissionPercentage
              this.contract = this.negotiatedTableTooltips[x].commissionResponse.contract
            }
          }
          // Here ends publicRates Tables
          for(var x = 0; x < this.negotiatedTooltipsText.length; x++) {
            if(this.whichNightSelected == this.negotiatedTooltipsText[x].night ) {
              this.tooltipBody = this.negotiatedTooltipsText[x].body
              this.tooltipTitle = this.negotiatedTooltipsText[x].title
            }
          }
        } if(this.tabActive == 2) {
          // HERE COMES PUBLIC RATES
          for(var x = 0; x < this.publicTooltipsText.length; x++) {
            if(this.whichNightSelected == this.publicTooltipsText[x].night) {
              this.tooltipBody = this.publicTooltipsText[x].body
              this.tooltipTitle = this.publicTooltipsText[x].title
            }
          }
          // HERE ENDS PUBLIC RATES
          // Here comes publicRates tables
          for(var x = 0; x < this.publicTooltipsTables.length; x++) {
            if(this.whichNightSelected == this.publicTooltipsTables[x].night) {
              this.baseAmount = this.publicTooltipsTables[x].commissionResponse.baseAmount
              this.commissionAmount = this.publicTooltipsTables[x].commissionResponse.commissionAmount
              this.commissionPercentage = this.publicTooltipsTables[x].commissionResponse.commissionPercentage
              this.contract = this.publicTooltipsTables[x].commissionResponse.contract
            }
          }
          // Here ends publicRates Tables
        }
      },
      roomCodeForTextTooltip() {
        if(this.tabActive == 1) {   // THIS SHOWS I'M DEALING WITH NEGOTIATED RATES
          // Here I'm done with table tooltip or commisionableRate: true
          this.publicTooltipsTables
          this.negotiatedTableTooltips
          if(this.negotiatedTableTooltips.length != 0) {
            for(var x = 0; x < this.negotiatedTableTooltips.length; x++) {
              if(this.roomCodeForTextTooltip == this.negotiatedTableTooltips[x].roomCode) {
                this.showTableTooltip = true
              } else {
                this.showTableTooltip = false
              }
            }
          }
          else {
          }
          // Here I'm done with table tooltip or commisionableRate: true
          // Here I'm done with text tooltip or commisionableRate:false
          for(var x = 0; x < this.negotiatedTooltipsText.length; x++) {
            if(this.roomCodeForTextTooltip == this.negotiatedTooltipsText[x].roomCode) {
              this.tooltipBody = this.negotiatedTooltipsText[x].body
              this.tooltipTitle = this.negotiatedTooltipsText[x].title
              this.showTextTooltip = true
            } else {
              this.showTextTooltip = false
            }
          }
          // Here I'm done with text tooltip or commisionablerate:false
        } if(this.tabActive ==2) {
// PUBLIC RATES
          if(this.publicTooltipsText.length == 0) {
            this.showTextTooltip = false
          }
          // Here I'm done with table tooltip or commisionableRate: true
          this.publicTooltipsTables
          if(this.publicTooltipsTables.length != 0) {
            for(var x = 0; x < this.publicTooltipsTables.length; x++) {
              if(this.roomCodeForTextTooltip == this.publicTooltipsTables[x].roomCode) {
                this.showTableTooltip = true
              } else {
                this.showTableTooltip = false
              }
            }
          }
          else {
          }
          // Here I'm done with table tooltip or commisionableRate: true
          for(var x = 0; x < this.publicTooltipsText.length; x++) {
            if(this.roomCodeForTextTooltip == this.publicTooltipsText[x].roomCode) {
              this.tooltipBody = this.publicTooltipsText[x].body
              this.tooltipTitle = this.publicTooltipsText[x].title
              this.showTextTooltip = true
            } else {
              this.showTextTooltip = false
            }
          }
        }
      },
      tabActive() {
        if(this.tabActive == 1) {
          this.masResultados = false

          this.showRatesDepends = false
          this.renderCombinedRooms = false
          this.banRenderRoomList = false
          this.showMorePublicRates = false
          this.roomCodeForTextTooltip = ''
          this.showTableTooltip = false
          this.showTextTooltip = false
        } else {
          this.roomCodeForTextTooltip = ''
          this.showTableTooltip = false
          this.showTextTooltip = false


          if(this.tabActive == 2 ) {

            if( this.morePublicRates == null || this.morePublicRates == [] || this.morePublicRates.length == 0) {
              this.showRatesDepends = false
            } else {
              this.showRatesDepends = true
            }
          }   else {
            this.showRatesDepends = false
          }
        }
      }
    },
    methods: {
//KB48764 m.a.cortes: monto incorrecto CYC
     changePolicy(  policyDesc, rate,guiones,rateActive,tCliente){     
          
            if(policyDesc.includes(this.twoPolicyEn) || policyDesc.includes(this.twoPolicy)){ 
              let rateUltimateTwo = this.average/this.noches;
               rateUltimateTwo = rateUltimateTwo.toFixed(2);
              var twonoches= rateUltimateTwo*2;
              policyDesc= policyDesc.replace(rate,`$${twonoches.toLocaleString('en')}`);                          
            }else{ 
                let rateUltimate = this.average/this.noches;    
                rateUltimate = rateUltimate.toFixed(2);                           
                policyDesc= policyDesc.replace(rate,`$${rateUltimate.toLocaleString('en')}`);
            }            
          if(tCliente=='PYP'||tCliente=='PYPSA'){
                console.log("ES PYP OR PYPSA");
                    if(rateActive==1){
                      policyDesc=policyDesc.replace(rate,guiones);
                    }
                  policyDesc=policyDesc;
                    return policyDesc;
                  }
            return policyDesc;
	  },
      
      closeModalImportant(){
        this.isModalPoliticasVisible = false;
        var availibilityRequest = {
          hotelName: '',
          hotelCode: '',
          arrivalDate: '',
          departureDate: '',
          currencyCode: 'MXN',
          totalAdults: 1,
          totalChildren: 0,
          totalInfants: 0,
          totalRooms: 1,
          agreementCode: '',
          iataCode: '',
          motivaCode: '',
          discountCode: '',
          promoCode: '',
          profileType: '',
          roomCodeList: [],
          selectedRooms: [],
          beautiDateInput:   '',
          beautiDateOutput:   ''
        }
        this.ls.set('availibilityRequest', {data: availibilityRequest});
        setTimeout(() => {
          this.$router.push({ name: "Reservaciones" });
        }, 10);
      },
      consideracionesEspeciales(data){
        if (data.data.response.specialMessage.length != 0) {
          this.dataConsiEspe.status = 'true';
          this.dataConsiEspe.aviso = data.data.response.specialMessage[0];
        } else {
          this.dataConsiEspe.status = false;
          this.dataConsiEspe.aviso = '';
        }
        this.datosHabHot.specialMessage = data.data.response.specialMessage;
        this.datosHabHot.mojito = data.data.response.mojito;
      },
      closeExpiredModal() {
        this.isExpiredModalVisible = false
        var ls = new SecureLS({encodingType: 'aes'});
        GlobalFunctions.localStorageClean();
        this.$router.push({ name: "Login" });
      },
      closeModalSpecialMessage() {
        this.modalSpecialMessage = false
      },
      clearLocalStorage() {
        this.isExpiredModalVisible = true
      },
      changeLanguage(){
        if (this.contTitleBusquedaTarifa === 0) {
          this.contTitleBusquedaTarifa ++;
        } else {
          this.banTitleBusquedaTarifa = false;
          setTimeout(() => {
            const avaReq = this.ls.get('availibilityRequest').data;
            var availibilityRequest = {
              hotelCode: avaReq.hotelCode,
              arrivalDate: avaReq.beautiDateInput,
              departureDate: avaReq.beautiDateOutput,
              currencyCode: avaReq.currencyCode,
              totalAdults: avaReq.totalAdults,
              totalChildren: avaReq.totalChildren,
              totalInfants: avaReq.totalInfants,
              totalRooms: avaReq.totalRooms,
              contractCode: "",
              agreementCode: avaReq.agreementCode,
              iataCode: avaReq.iataCode,
              motivaCode: avaReq.motivaCode,
              discountCode: avaReq.discountCode,
              promoCode: avaReq.promoCode,
              profileType: avaReq.profileType,
              roomCodeList: avaReq.roomCodeList,
            }
            if( this.ls.get('Language').data === 'en') {
              availibilityRequest.currencyCode = 'USD';
              var date = availibilityRequest.arrivalDate;
              var date2 = availibilityRequest.departureDate;
              var datearray = date.split("/");
              var datearray2 = date2.split("/");
              var newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
              var newdate2 = datearray2[1] + '/' + datearray2[0] + '/' + datearray2[2];
              availibilityRequest.arrivalDate = newdate
              availibilityRequest.departureDate = newdate2
            }
            var contractCodes = this.ls.get('contractCodesLangProblem').data
            this.loaderSolution(this.ls.get('Token').data, this.$store.getters.gettingLang,avaReq,availibilityRequest,contractCodes)
          }, 1);
        }
/// End of method
      },
      loaderSolution(token,lang,avaReq,availibilityRequest,contractCodes) {
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
          brandCode: avaReq.brandCode,
          hotelCode: availibilityRequest.hotelCode,
          contractCodes: contractCodes,
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer ' + token,
            'Content-Type' : 'application/json',
            'Accept-Language' : this.ls.get('Language').data // lang
          }
        })
          .then(res => {
            var resObject=JSON.parse(JSON.stringify(res));
            if ( resObject.status == 200 || resObject.status == 201) {
              this.ls.set('DetailHotelInfo', {data: resObject.data});
                        this.componentKey2 += 1  
              this.$store.commit('hotelInfoIsSet');
              this.puff();
            }
          })
          .catch(error=>{
            // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
            let errorObject=JSON.parse(JSON.stringify(error));
            if (errorObject.message == 'Request failed with status code 401') {
              this.clearLocalStorage()
            }
          })
      },
      loaderProblem(availibilityRequest,token,lang,avaReq) {
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_HOTEL + `/` + process.env.VUE_APP_AVAILIBILITY, availibilityRequest, {
          withCredentials: true,
          credentials: 'include',
          headers: {'Authorization': 'Bearer ' + token,
            'Content-Type' : 'application/json',
            'Accept-Language' : lang
          }
        })
          .then(res1 => {
            var resObject=JSON.parse(JSON.stringify(res1));
            if ( resObject.status == 200 || resObject.status == 201) {
              this.ls.set('BusquedaPorTarifaInfo', {data: resObject.data});
              if( (resObject.data.response.negotiatedRates == [] || resObject.data.response.negotiatedRates.length == 0 ) && resObject.data.response.publicRates.length != 0) {
                this.$store.commit('clickPublic')
                this.ls.set('justPublicSir', {data: true});
                var contractCodes = [];
                for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
                  contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
                }
                for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
                  contractCodes.push(resObject.data.response.publicRates[i].contractCode)
                }
                var names = this.contractCodes.reduce(function (a, b) {
                  if (a.indexOf(b) == -1) {
                    a.push(b)
                  }
                  return a;
                }, []);
                contractCodes = names
                axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
                  brandCode: avaReq.brandCode,
                  hotelCode: availibilityRequest.hotelCode,
                  contractCodes: contractCodes,
                }, {
                  withCredentials: true,
                  credentials: 'include',
                  headers: {'Authorization': 'Bearer ' + token,
                    'Content-Type' : 'application/json',
                    'Accept-Language' : this.ls.get('Language').data // lang
                  }
                })
                  .then(res => {
                    var resObject=JSON.parse(JSON.stringify(res));
                    if ( resObject.status == 200 || resObject.status == 201) {
                      this.ls.set('DetailHotelInfo', {data: resObject.data});
                        this.componentKey2 += 1  
                      this.$store.commit('hotelInfoIsSet');
                      this.puff();
                    }
                  })
                  .catch(error=>{
                    // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
                    let errorObject=JSON.parse(JSON.stringify(error));
                    if (errorObject.message == 'Request failed with status code 401') {
                      this.clearLocalStorage()
                    }
                  })
              }
              if(resObject.data.response.negotiatedRates.length != 0 && resObject.data.response.publicRates.length != 0) {
                contractCodes = []
                for(var i = 0; i < resObject.data.response.negotiatedRates.length; i++) {
                  contractCodes.push(resObject.data.response.negotiatedRates[i].contractCode)
                }
                for(var i = 0; i < resObject.data.response.publicRates.length; i++) {
                  contractCodes.push(resObject.data.response.publicRates[i].contractCode)
                }
                var names = contractCodes.reduce(function (a, b) {
                  if (a.indexOf(b) == -1) {
                    a.push(b)
                  }
                  return a;
                }, []);
                contractCodes = names
                axios.post(process.env.VUE_APP_HOSTCORPORATEAPI +process.env.VUE_APP_CORPORATEAPI  + process.env.VUE_APP_DETAILDHOTEL, {
                  brandCode: avaReq.brandCode,
                  hotelCode: availibilityRequest.hotelCode,
                  contractCodes: contractCodes,
                }, {
                  withCredentials: true,
                  credentials: 'include',
                  headers: {'Authorization': 'Bearer ' + token,
                    'Content-Type' : 'application/json',
                    'Accept-Language' : this.ls.get('Language').data // lang
                  }
                })
                  .then(res => {
                    var resObject=JSON.parse(JSON.stringify(res));
                    if ( resObject.status == 200 || resObject.status == 201) {
                      this.ls.set('DetailHotelInfo', {data: resObject.data});
                        this.componentKey2 += 1  
                   this.$store.commit('hotelInfoIsSet');
                      this.puff();
                    }
                  })
                  .catch(error=>{
                    // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
                    let errorObject=JSON.parse(JSON.stringify(error));
                    if (errorObject.message == 'Request failed with status code 401') {
                      this.clearLocalStorage()
                    }
                  })
              }
            }
            // When service breaks and doesn´t throw a successful answer
            if(resObject.status == 401) {
              this.clearLocalStorage()
            }
          })
          .catch(error=>{
            // Error server
 if( (error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02" ) ) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
// Error server 
            if (error.response.status == 401) {
              this.clearLocalStorage()
            }
          });
      },
      puff() {
        this.banNR = true
        this.banPR = true
        setTimeout( () => {
          this.banTitleBusquedaTarifa = true;
          this.tabActive = 1
          this.rooms = []
          this.morePublicRates = []
          this.language = this.ls.get('Language'); // set key1
          var a = ''
          a = this.ls.get('Token') 
          this.token = a.data.substr(1);
          var ratingsInfo = this.ls.get('BusquedaPorTarifaInfo')  
          var detailHotelInfo = this.ls.get('DetailHotelInfo')
          this.consideracionesEspeciales(detailHotelInfo);
          this.codigoHotel = detailHotelInfo.data.response.hotelCode;
          this.hotelsCards(this.codigoHotel);

          if(detailHotelInfo.data.response.hotelMailImage == null) {
            this.hotelMailImage = ''
            this.ls.set('hotelMailImage', {data:this.hotelMailImage})
          } else {
            this.hotelMailImage = detailHotelInfo.data.response.hotelMailImage
            this.ls.set('hotelMailImage', {data:this.hotelMailImage})
          }
          var morePublicRates = ratingsInfo.data.response.morePublicRates
          this.morePublicRates = ratingsInfo.data.response.morePublicRates
          if(this.tabActive == 2 ) {

            if( morePublicRates == null || morePublicRates == [] || morePublicRates.length == 0) {
              this.showRatesDepends = false
            } else {
              this.showRatesDepends = true
            }
          }   else {
            this.showRatesDepends = false

          }
          var negotiatedTootips = []
          var negotiatedTables = []
          var negotiatedRates = ratingsInfo.data.response.negotiatedRates
          for(var i = 0; i < negotiatedRates.length; i++) {
            for( var j = 0; j < negotiatedRates[i].ratesDetailResponses.length; j++) { 
              if(negotiatedRates[i].ratesDetailResponses[j].commissionableRate == false) {
                for(var e = 0; e < detailHotelInfo.data.response.ratePolicyInfoResponseList.length; e++) {
                  if(  negotiatedRates[i].contractCode == detailHotelInfo.data.response.ratePolicyInfoResponseList[e].contractCode ) {
                    var benefits = detailHotelInfo.data.response.ratePolicyInfoResponseList[e].benefits
                    var restrictions = detailHotelInfo.data.response.ratePolicyInfoResponseList[e].restrictions
                    var bodyM = benefits.concat(restrictions);
                    negotiatedTootips.push({
                      roomCode: negotiatedRates[i].roomCode,
                      title: detailHotelInfo.data.response.ratePolicyInfoResponseList[e].rateDescription,
                      body: bodyM,
                      night: negotiatedRates[i].ratesDetailResponses[j].reservationDate
                    })
                  } else {
                  }
                }
              } else {
                // Here is where I fill my object of commisionablerate: true for negotiatedRates
                negotiatedTables.push({
                  roomCode: negotiatedRates[i].roomCode,
                  commissionResponse: negotiatedRates[i].ratesDetailResponses[j].commissionResponse,
                  night: negotiatedRates[i].ratesDetailResponses[j].reservationDate
                })
              }
            }
          }
          // Deleting repeated elements for text tooltip
          var names =  negotiatedTootips.reduce(function (a, b) {
            if (a.indexOf(b) == -1) {
              a.push(b)
            }
            return a;
          }, []);
// Deleting repeated elements for table tooltips
          var justPuretables =  negotiatedTables.reduce(function (a, b) {
            if (a.indexOf(b) == -1) {
              a.push(b)
            }
            return a;
          }, []);
          // Setting clean arrays
          negotiatedTootips = names
          this.negotiatedTooltipsText = negotiatedTootips
          this.negotiatedTableTooltips = justPuretables
          // Now it only lacks getting the publicRate tooltips for commisionablerate: false OR Text Tooltip
          // Here STARTS
          var publicRatesTootips = []
          var publicRatesTables = []
          for (var liMore of morePublicRates) {
            if (liMore.rateType == 'Tarifa Combinada' || liMore.rateType == 'Mixed Rate') {
              this.banEtiquetaMasTarifas = true;
            }
          }
          var publicRates = ratingsInfo.data.response.publicRates
          for(var i = 0; i < publicRates.length; i++) {
            if (publicRates[i].rateType == 'Tarifa Combinada' || publicRates[i].rateType == 'Mixed Rate') {
              this.banEtiquetaMasTarifas = true;
            }
            for( var j = 0; j < publicRates[i].ratesDetailResponses.length; j++) {
              /// Combien de nuits a-t-ils ?
              if(publicRates[i].ratesDetailResponses[j].commissionableRate == false) {
                for(var e = 0; e < detailHotelInfo.data.response.ratePolicyInfoResponseList.length; e++) {
                  if(  publicRates[i].contractCode == detailHotelInfo.data.response.ratePolicyInfoResponseList[e].contractCode ) {
                    var benefits = detailHotelInfo.data.response.ratePolicyInfoResponseList[e].benefits
                    var restrictions = detailHotelInfo.data.response.ratePolicyInfoResponseList[e].restrictions
                    var bodyM = benefits.concat(restrictions);
                    publicRatesTootips.push({
                      roomCode: publicRates[i].roomCode,
                      title: detailHotelInfo.data.response.ratePolicyInfoResponseList[e].rateDescription,
                      body: bodyM,
                      night: publicRates[i].ratesDetailResponses[j].reservationDate
                    })
                  } else {
                  }
                }
              } else {
                // Here is where I set my publicRates commissionableRates : true
                publicRatesTables.push({
                  roomCode: publicRates[i].roomCode,
                  commissionResponse: publicRates[i].ratesDetailResponses[j].commissionResponse,
                  night: publicRates[i].ratesDetailResponses[j].reservationDate
                })
              }
            }
          }
          // Setting clean objects
          // publicRates for text
          var names2 =  publicRatesTootips.reduce(function (a, b) {
            if (a.indexOf(b) == -1) {
              a.push(b)
            }
            return a;
          }, []);
          publicRatesTootips = names2
          this.publicTooltipsText = publicRatesTootips
          // publicRates for tables
          var noMore =  publicRatesTables.reduce(function (a, b) {
            if (a.indexOf(b) == -1) {
              a.push(b)
            }
            return a;
          }, []);
          this.publicTooltipsTables = noMore
          // Here ENDS
          this.hotelName = detailHotelInfo.data.response.hotelName
          this.hotelDescription = (detailHotelInfo.data.response.hotelDescription===null||detailHotelInfo.data.response.hotelDescription===''?i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'):detailHotelInfo.data.response.hotelDescription)
          this.hotelMainImage = (detailHotelInfo.data.response.hotelMainImage===null||detailHotelInfo.data.response.hotelMainImage===''?i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'):detailHotelInfo.data.response.hotelMainImage)

          this.hotelCarrouselImages = detailHotelInfo.data.response.hotelCarrouselImages
          this.justForFun = []
          this.amenityListRight = []
          this.amenityList = []
          if (detailHotelInfo.data.response.hotelCarrouselImages === null || detailHotelInfo.data.response.hotelCarrouselImages.length === 0) {
            this.justForFun.push({id:'', src: '', thumbnail: ''});
          } else {
            for(var i = 0; i < this.hotelCarrouselImages.length; i++) {
              this.justForFun.push({id:i, src: this.hotelCarrouselImages[i], thumbnail: this.hotelCarrouselImages[i]});
            }
          }
          this.hotelPhone = detailHotelInfo.data.response.hotelPhone
          this.hotelFax = detailHotelInfo.data.response.hotelFax
          this.hotelAddress = detailHotelInfo.data.response.hotelAddress
          this.srcMaps = process.env.VUE_APP_APIMAPS + detailHotelInfo.data.response.hotelLatitude + ',' + detailHotelInfo.data.response.hotelLongitude + '&hl=es;z=14&output=embed'
          for(var i = 0; i < detailHotelInfo.data.response.amenityList.length; i++) {
            if (i < 6) {
              this.amenityList.push({
                amenityName: detailHotelInfo.data.response.amenityList[i].amenityName,
                amenityIcon: detailHotelInfo.data.response.amenityList[i].amenityIcon
              });
            } else {
              this.amenityListRight.push({
                amenityName: detailHotelInfo.data.response.amenityList[i].amenityName,
                amenityIcon: detailHotelInfo.data.response.amenityList[i].amenityIcon
              });
            }
          }
          this.banRenderRoomList = true;
          this.datosHabHot.countryDir = detailHotelInfo.data.response.hotelCountry;
          this.datosHabHot.cityDir = detailHotelInfo.data.response.hotelCity;
          var listTar = [];
          if(ratingsInfo.data.response.negotiatedRates.length == 0 || ratingsInfo.data.response.negotiatedRates == null || ratingsInfo.data.response.negotiatedRates == undefined){
            this.banNR = false;
            listTar = ratingsInfo.data.response.publicRates;
            this.tarifasPublicasParaFusion =    listTar
            this.tabActive = 2;
            this.datosHabHotModalCosto.tabActive = 2;
          } else{
            if(ratingsInfo.data.response.publicRates.length == 0 || ratingsInfo.data.response.publicRates == null || ratingsInfo.data.response.publicRates == undefined){
              this.banPR = false;
              listTar = ratingsInfo.data.response.negotiatedRates;
              this.tabActive = 1;
              this.datosHabHotModalCosto.tabActive = 1;
            } else {
              listTar = ratingsInfo.data.response.negotiatedRates;
              this.tabActive = 1;
              this.datosHabHotModalCosto.tabActive = 1;
            }
          }

          // COMIENZA ordenar la lista de hoteles MOREPUBLICRATES tomando como base la lista de tarifas y mostarndo la informacion que haga match con hotelDetail

          this.orderListRoomsForTaxesService(ratingsInfo.data.response.morePublicRates, detailHotelInfo.data.response.roomDetailResponseList, detailHotelInfo.data.response.ratePolicyInfoResponseList).then(response => {
            //ordenar la lista de mayor a menor
            this.orderListRoomsForMenorMayor(response, 'menorAMayor').then(respon => {
              this.morePublicRates = respon;
            });
          });
          // FIN DE ordenar la lista de hoteles MOREPUBLICRATES  tomando como base la lista de tarifas y mostarndo la informacion que haga match con hotelDetail
          // ordenar la lista de hoteles tomando como base la lista de tarifas y mostarndo la informacion que haga match con hotelDetail
          this.orderListRoomsForTaxesService(listTar, detailHotelInfo.data.response.roomDetailResponseList, detailHotelInfo.data.response.ratePolicyInfoResponseList).then(response => {
            //ordenar la lista de mayor a menor
            this.orderListRoomsForMenorMayor(response, 'menorAMayor').then(respon => {
              this.rooms = respon;
            });
          });
        }, 1);
      },
      orderListRoomsForTaxesService(listRates, listRoomDetailResponseList, ratePolicyInfoResponseList){
        return new Promise ((resolve, reject) => {
          var rms = [];
          const hotelConfiguration = this.ls.get("hotelConfiguration");
          for (let i = 0; i < listRates.length; i++) {
            rms.push({
              title: i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'),
              desc: i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'),
              price: listRates[i].totalRateWithTaxes, 
              img: i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'),
              elipse: true,
              roomCode: listRates[i].roomCode,  
              nights: listRates[i].nights,
              negotiatedRatesDetailPrice: listRates[i],
              benefitsRestrictions: null
            });
            for (var j = 0; j < listRoomDetailResponseList.length; j++) {
              if (listRates[i].roomCode == listRoomDetailResponseList[j].roomCode) {
                rms[i].title = listRoomDetailResponseList[j].roomName;
                rms[i].desc = (listRoomDetailResponseList[j].roomDescription==null||listRoomDetailResponseList[j].roomDescription==''?i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'):listRoomDetailResponseList[j].roomDescription);
                rms[i].img = (listRoomDetailResponseList[j].roomImage==null||listRoomDetailResponseList[j].roomImage==''?i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible'):listRoomDetailResponseList[j].roomImage);
                rms[i].roomCode = listRoomDetailResponseList[j].roomCode;
              }
            }
            for (let k = 0; k < ratePolicyInfoResponseList.length; k++) {
              if (listRates[i].contractCode == ratePolicyInfoResponseList[k].contractCode) {
                rms[i].benefitsRestrictions = ratePolicyInfoResponseList[k];
              }
            }

            if (rms[i].title == i18n.t('language.posadasCorporate.busquedaPorTarifa.contenidoNoDisponible')) {
              for(let l = 0; l < hotelConfiguration.length; l++) {
                for(let m = 0; m < hotelConfiguration[l].roomCodes.length; m++) {
                  if (rms[i].roomCode == hotelConfiguration[l].roomCodes[m]) {
                    rms[i].title = hotelConfiguration[l].categoryName;
                  }
                }
              }
            }

          }
          resolve(rms);
        });
      },
      orderListRoomsForMenorMayor(listaOrdenar, operador){
        return new Promise ((resolve, reject) => {
          var temporal = null;
          for (var i = 0;i < listaOrdenar.length; i++){
            for (var j = 0; j< listaOrdenar.length-1; j++){
              if (listaOrdenar[j].price < listaOrdenar[j+1].price && operador === 'mayorAMenor'){
                temporal = listaOrdenar[j];
                listaOrdenar[j] = listaOrdenar[j+1];
                listaOrdenar[j+1] = temporal;
              }
              if (listaOrdenar[j].price > listaOrdenar[j+1].price && operador === 'menorAMayor'){
                temporal = listaOrdenar[j];
                listaOrdenar[j] = listaOrdenar[j+1];
                listaOrdenar[j+1] = temporal;
              }
            }
          }
          resolve(listaOrdenar);
        });
      },
      selectRoom: function(room, index){
        this.banSelectedRoom = true;
        this.idxDetailCosto = index;
        this.datosHabHot.habitacion = this.ls.get('availibilityRequest').data;
        //en datosHabHot.hotel van los datos del hotel y los datos de la tarifa
        this.datosHabHot.hotel = room;
        this.datosHabHot.hotelName = this.hotelName;
        var availibilityRequest = this.ls.get('availibilityRequest');

        if (this.datosHabHot.hotel.benefitsRestrictions === null || this.datosHabHot.hotel.benefitsRestrictions === undefined) {
          this.ls.set("rateDesEr", "");
        } else {
          this.ls.set("rateDesEr", this.datosHabHot.hotel.benefitsRestrictions.rateDescription);
        }
        this.ls.set('nuitsPourS', this.datosHabHot.hotel.nights)
// modal aviso importante genera problemas
  
        const profile = this.ls.get('Profile').data;
        var dataPoliticas = {
          userType: profile.userType,
          contractType: this.datosHabHot.hotel.negotiatedRatesDetailPrice.contractType,
          discountCode: this.datosHabHot.habitacion.discountCode
        };
        GlobalServices._consultaPoliticasViaje(dataPoliticas, this.ls.get('Token').data, this.ls.get('Language').data).then(reponsePoliticas => {
          if (reponsePoliticas.status === 200) {
            if (reponsePoliticas.data.length === 0 && profile.profileId === 'POSADAS') {
              this.banSelectedRoom = false;
              this.isModalPoliticasVisible = true;            
            } else {
              if (this.politicas.listPoliticas === null || this.politicas.privacyPolicyURL === null) {
                //if (this.politicas.listPoliticas === null) {
                this.consultaPoliticaCambioCancelcion(room, 2);
              } else{
                this.datosHabHot.politicas = this.politicas;
                this.selectedHotel();
              }
            }
          }
        }).catch(error => {
        let errorObject=JSON.parse(JSON.stringify(error));
          if (error.status === 401) {
            this.clearLocalStorage();
          }
//Server Error 

           if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error2" });
} 
        });
      },
      editRoom: function(){
        this.selectedRoom = null;
      },
      redirectMap(){
        window.open(this.srcMaps.replace('embed','iframe'), '_blank');
      },

    
      whichRoomCode(room, roomCode, index) {
        this.componentKey += 1;
        var availibilityRequest = this.ls.get('availibilityRequest').data;
        this.datosHabHotModalCosto.localStor = 'datosHabHotSelected';
        this.datosHabHotModalCosto.hotel = room;

        if(this.tabActive == 1) {
          this.datosHabHotModalCosto.whichRates = 'Negociadas';

        }
        if(this.tabActive == 2) {
          this.datosHabHotModalCosto.whichRates = 'Publicas';

        }

        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Public Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Pública'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Pública') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Public Rate'
        }

        if(this.$store.getters.gettingLang == 'es' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Negotiated Rate') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Tarifa Negociada'
        }
        if(this.$store.getters.gettingLang == 'en' && this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType == 'Tarifa Negociada') {
          this.datosHabHotModalCosto.hotel.negotiatedRatesDetailPrice.rateType = 'Negotiated Rate'
        }

        this.datosHabHotModalCosto.habitacion = availibilityRequest;
        this.ls.set('updateCostDetail', {data: this.datosHabHotModalCosto}) // TEST
        this.banModDetCosto = true;
        this.banDetCost = true;
        setTimeout(() => {
          this.$bvModal.show('detalleDeCosto1');
        }, 20);
        this.idxDetailCosto = index;
        this.roomCodeForTextTooltip = roomCode
      },
      saveModalCost(room){
        var availibilityRequest = this.ls.get('availibilityRequest').data;
        this.datosHabHotModalCosto.localStor = 'datosHabHotSelected';
        this.datosHabHotModalCosto.hotel = room;
        this.datosHabHotModalCosto.habitacion = availibilityRequest;
        this.ls.set('updateCostDetail', {data: this.datosHabHotModalCosto});

      },
      whichNight(night) {
        this.whichNightSelected = night
        if(this.tabActive == 1) {
          // Here comes negotiatedRates tables
          for(var x = 0; x < this.negotiatedTableTooltips.length; x++) {
            if(this.whichNightSelected == this.negotiatedTableTooltips[x].night) {
              this.baseAmount = this.negotiatedTableTooltips[x].commissionResponse.baseAmount
              this.commissionAmount = this.negotiatedTableTooltips[x].commissionResponse.commissionAmount
              this.commissionPercentage = this.negotiatedTableTooltips[x].commissionResponse.commissionPercentage
              this.contract = this.negotiatedTableTooltips[x].commissionResponse.contract
            }
          }
          // Here ends publicRates Tables
          for(var x = 0; x < this.negotiatedTooltipsText.length; x++) {
            if(this.whichNightSelected == this.negotiatedTooltipsText[x].night ) {
              this.tooltipBody = this.negotiatedTooltipsText[x].body
              this.tooltipTitle = this.negotiatedTooltipsText[x].title
            }
          }
        } if(this.tabActive == 2) {
          // HERE COMES PUBLIC RATES
          for(var x = 0; x < this.publicTooltipsText.length; x++) {
            if(this.whichNightSelected == this.publicTooltipsText[x].night) {
              this.tooltipBody = this.publicTooltipsText[x].body
              this.tooltipTitle = this.publicTooltipsText[x].title
            }
          }
          // HERE ENDS PUBLIC RATES
          // Here comes publicRates tables
          for(var x = 0; x < this.publicTooltipsTables.length; x++) {
            if(this.whichNightSelected == this.publicTooltipsTables[x].night) {
              this.baseAmount = this.publicTooltipsTables[x].commissionResponse.baseAmount
              this.commissionAmount = this.publicTooltipsTables[x].commissionResponse.commissionAmount
              this.commissionPercentage = this.publicTooltipsTables[x].commissionResponse.commissionPercentage
              this.contract = this.publicTooltipsTables[x].commissionResponse.contract
            }
          }
          // Here ends publicRates Tables
        }
      },
      tarifas(tipoTarifa){
        this.banRenderRoomList = false;
        setTimeout(() => {
          this.banRenderRoomList = true;
        }, 1);
        let ratingsInfo = this.ls.get('BusquedaPorTarifaInfo');
        let detailHotelInfo = this.ls.get('DetailHotelInfo');
        this.banMM = false;
        let listTar = [];
        if (tipoTarifa === 1) {
          listTar = ratingsInfo.data.response.negotiatedRates;
          this.datosHabHotModalCosto.tabActive = 1;
        }
        if (tipoTarifa === 2) {
          listTar = ratingsInfo.data.response.publicRates;
          this.tarifasPublicasParaFusion =    listTar
          this.datosHabHotModalCosto.tabActive = 2;
        }

        // ordenar la lista de hoteles tomando como base la lista de tarifas y mostarndo la informacion que haga match con hotelDetail
        this.orderListRoomsForTaxesService(listTar, detailHotelInfo.data.response.roomDetailResponseList, detailHotelInfo.data.response.ratePolicyInfoResponseList).then(response => {
          //ordenar la lista de mayor a menor
          this.orderListRoomsForMenorMayor(response, 'menorAMayor').then(respon => {
            this.rooms = respon;
          });
        });
      },
      orderMenorMayor(operador){

        this.mixedPublicRates = []
        this.roomsCombined = []
        var ratingsInfo = this.ls.get('BusquedaPorTarifaInfo')
        var    listTar = ratingsInfo.data.response.publicRates;
        this.tarifasPublicasParaFusion =    listTar
        if((this.renderCombinedRooms || this.showMorePublicRates) && this.tabActive == 2) {
          this.mixedPublicRates = this.tarifasPublicasParaFusion

          for(var i = 0; i < this.morePublicRates.length; i++) {
            this.mixedPublicRates.push(this.morePublicRates[i].negotiatedRatesDetailPrice)
          }
          this.banRenderRoomList = false
          this.showMorePublicRates = false
          let detailHotelInfo = this.ls.get('DetailHotelInfo');
          this.banMM = (operador==='menorAMayor'?false:true);


          // Ordenar de mayor a menor
          this.orderListRoomsForTaxesService(this.mixedPublicRates, detailHotelInfo.data.response.roomDetailResponseList, detailHotelInfo.data.response.ratePolicyInfoResponseList).then(response => {
            //ordenar la lista de mayor a menor
            this.orderListRoomsForMenorMayor(response, operador).then(respon => {

              this.roomsCombined = respon;
              this.renderCombinedRooms = true
            });
          });

        } else {


          this.banRenderRoomList = false;
          setTimeout(() => {
            this.banRenderRoomList = true;
          }, 1);
          this.banMM = (operador==='menorAMayor'?false:true);
          this.orderListRoomsForMenorMayor(this.rooms, operador).then(responseOrder => {
            this.rooms = responseOrder;
          });
        }
      },
      selectedHotel(){
        this.$store.commit('blockLanguages', {turn: true})
        this.ls.set('blocklanguages',{data: true, data1: 1}) // data1 = (0: noBlock, 1: block)
        this.datosHabHot.localStor = 'datosHabHotSelected';
        this.datosHabHot.userClientID = this.datosHabHotModalCosto.userClientID;
        this.datosHabHot.tabActive = this.datosHabHotModalCosto.tabActive;
        this.ls.set('datosHabHotSelected', {data: this.datosHabHot});
        this.ls.set('rateTypeForReservationRequest', { data: this.ls.get('datosHabHotSelected').data.hotel.negotiatedRatesDetailPrice.rateType } )
        this.banSelectedRoom = false;
        if(this.ls.get("choosingEditing")) {
          this.$router.push({ name: 'ReservacionesModificacionLectura'})
        } else {
        this.$store.commit('changePersistRegistryData', true)
          this.$router.push({ name: 'ReservacionesRegistro'})
        }
      },
      consultaPoliticaCambioCancelcion(room, lugarPeticion){
        let bodyRatePolicy = {
          hotelCode: '',
          arrivalDate: '',
          departureDate: '',
          contractCode: '',
          contractType: null,
          currencyCode: '',
          showRates: null,
          showPublicRates: null,
          hasCombinedRate: null,
          dailyRate: null,
          totalRate: null,
        };
        const detailHotelInfo = this.ls.get('DetailHotelInfo').data.response;
        const availibilityRequest = this.ls.get('availibilityRequest').data;
        const profile = this.ls.get('Profile').data;
        var infoCosto =  this.ls.get('updateCostDetail');
    
        bodyRatePolicy.hotelCode = detailHotelInfo.hotelCode;
        bodyRatePolicy.arrivalDate = availibilityRequest.beautiDateInput;
        bodyRatePolicy.departureDate = availibilityRequest.beautiDateOutput;
        bodyRatePolicy.contractCode = room.negotiatedRatesDetailPrice.contractCode;
        bodyRatePolicy.contractType = room.negotiatedRatesDetailPrice.contractType;
        bodyRatePolicy.currencyCode = (availibilityRequest.currencyCode===''?'MXN':availibilityRequest.currencyCode);
        bodyRatePolicy.showRates = profile.ratesPermissionsResponse.showRates;
        bodyRatePolicy.showPublicRates = profile.ratesPermissionsResponse.showPublicRates;
        bodyRatePolicy.hasCombinedRate = room.negotiatedRatesDetailPrice.hasCombinedRates;
        bodyRatePolicy.dailyRate = room.negotiatedRatesDetailPrice.ratesDetailResponses[0].roomCostWithoutTaxes;
        bodyRatePolicy.totalRate = room.negotiatedRatesDetailPrice.totalRateWithoutTaxes;
        this.average=bodyRatePolicy.totalRate;
        this.datosHabHot.hotel = room;
        this.noches=this.datosHabHot.hotel.nights;
     
       // average=bodyRatePolicy.totalRate
        GlobalServices._consultaPoliticasTarifas(this.ls.get('Token').data, this.ls.get('Language').data, bodyRatePolicy).then(response => {
          if (response.status === 200) {
            this.politicas.listPoliticas = response.data.ratePolicyElementResponseList;
            this.politicas.privacyPolicyURL = response.data.privacyPolicyURL;
            if (lugarPeticion === 1) {
              this.$bvModal.show('politicasCambioCancelacion')
            }
            if (lugarPeticion === 2) {
              //this.datosHabHot.politicas = response.data.ratePolicyElementResponseList;
              this.datosHabHot.politicas = this.politicas;
              this.selectedHotel();
            }
          }
        }).catch(error => {
// Error server
          if(error.response == null) {
            if(error.message == "Error while querying rate policies" || error.message == "Error al consultar politicas de tarifa") {
              this.$router.push({ name: "Error" });
            }
          }
          else if(error.response.status == 404 ||  error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504 ) {
            this.$router.push({ name: "Error" });
          }
          // Error server
          if (error.status === 401) {
            //token caduco
            this.sesionClose();
          }

        });
      },
      sesionClose(){
        this.isExpiredModalVisible = true

      },
      redirectPrivacyPolicy(){
        (this.ls.get('Language').data=='es'?window.open(process.env.VUE_APP_POLICIES, '_blank'):window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      closeModalTarifa() {
        this.isModalTarifa = false;
      },
      verMas() {
        // Usen este data para cambiar los estados y textos, es un booleano
        this.masResultados = true
        this.showMorePublicRates = true
        this.showFooterText = true
      },
      verMenos() {
        var ratingsInfo = this.ls.get('BusquedaPorTarifaInfo')
        var    listTar = ratingsInfo.data.response.publicRates;
        this.tarifasPublicasParaFusion =    listTar
        this.masResultados = false
        this.showMorePublicRates = false
        this.showFooterText = false
        this.renderCombinedRooms = false
        this.banRenderRoomList = true
      },
      hotelsCards(hotelCode){
      //Start KB41178
      GlobalServices._consultaHotelesHours().then(response => {
                for (let listBrand of response.hotelCode) {
                      if(listBrand.brandCode == hotelCode){
                              this.hotelCardEntrada = listBrand.horaEntrada;
                              this.hotelCardSalida = listBrand.horaSalida;
                      }
                }
      });
      //End KB41178
      }
    },
    created() {
      this.banEtiquetaMasTarifas = false;
      this.ls.set("isCopy", false)

      var ls = new SecureLS({encodingType: 'aes'});
      this.tipoClienteID = ls.get('ClientId').data;
      this.showRates = this.ls.get('Profile').data.ratesPermissionsResponse.showRates;
      this.datosHabHotModalCosto.userClientID = ls.get('ClientId').data;
      if(this.ls.get("choosingEditing")) {
        this.sidebarTopOff = false
      } else {
        this.sidebarTopOff = true
      }
      var aa = ls.get('justPublicSir');
      if( ls.get('seulNegotiated').data ) {
        this.banPR = false
      }
      var showSpecificMessage = ls.get('availibilityRequest')
      if(showSpecificMessage.data.totalRooms == 1) {
        this.justOne = true
        this.moreThanOne = false
      } else {
        this.justOne = false
        this.moreThanOne = true
      }
      setTimeout(function(){
        if(aa.data) {
          var lis = document.getElementById("sirPublic").getElementsByTagName("li");
          document.getElementById(lis[1].id).click();
        } else {
          var lis = document.getElementById("sirPublic").getElementsByTagName("li");
        }
      }, 1);
      this.banTitleBusquedaTarifa = false;
      if (this.contTitleBusquedaTarifa != 0) {
        this.puff()
      }

    },
    beforeCreate(){
      GlobalFunctions.tokenExistValidate().then(response => {
        if(!response){
          let ls = new SecureLS({encodingType: 'aes'});
          this.isExpiredModalVisible = true
          this.banToken = true;

        } else{
          this.banToken = true;
        }
      });
    },
  };
</script>

<style lang="scss" scoped>
  .verMas {
    font-weight: 500;
    cursor: pointer;
  }
  .tag-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  @import '../../../assets/scss/config.scss';
  .container-siderbarTop {
    padding-top: 140px;
  }
  .superTitle {
    height: 26px;
    font-size: $font-size-biglarge;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 0.4px;
    margin-bottom: 16px;
  }
  .reservaciones {
    width: 100%;
  }
  .filtros {
    font-size: $font-size-base;
    font-weight: 500;
    .iconFiltros {
      font-size: $font-size-biglarge;
      vertical-align: middle;
    }
  }
  .costosTable {
    width: 50%;
    display: inline-block;
    padding-bottom: 10px;
  }
  i {
    font-size: 18px;
  }
  .navi {
    display: none;
  }
  .titleReserva{
    position: relative;
    padding-right: 20px;
  }
  .camposActive {
    color: #0c5458;
    font-weight: 500;
  }
  .imagenMobilReserva {
    display: none;
  }
  .imagenDeskTopReserva {
    display: table-cell;
  }
  @media only screen and (max-width: 736px) {
    .container-siderbarTop {
      padding-top: 130px;
    }
    .costosTable {
      width: 100%;
      display: inline-block;
    }
    .list-inline {
      text-align: right;
    }
    .navi {
      display: block;
      float: right;
      position: absolute;
      top: 0;
      right: 0;
    }
    .imagenDeskTopReserva {
      display: none;
    }
    .imagenMobilReserva {
      display: block;
    }
    .infoReserva {
      width: 70%;
      padding: 16px;
      display: inline-block;
    }
    .infoReservaAbierto{
      padding: 16px;
    }
  }
</style>
